import React from 'react';

import Spacing from 'craft/components/Spacing';
import { useCss } from 'craft/hooks';
import { ToolboxComponentSchema } from 'craft/types';

interface Props {
  nodeIds: string[];
  schema: ToolboxComponentSchema['Spacing'];
  cssDefaults?: Record<string, any>;
}

export const CraftSpacing = ({ nodeIds, schema, cssDefaults = {} }: Props) => {
  const { cssSelectorId, hasMargin, hasPadding } = schema;
  const { css, setCss } = useCss(nodeIds, { cssSelectorId });

  return (
    <Spacing
      cssProps={{ ...cssDefaults, ...css }}
      setCss={setCss}
      isMarginEditable={hasMargin}
      isPaddingEditable={hasPadding}
      cssSelectorId={cssSelectorId}
      nodeIds={nodeIds}
    />
  );
};
